var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgSortUp = function SvgSortUp(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.75 21.25C10.75 21.9404 11.3096 22.5 12 22.5C12.6904 22.5 13.25 21.9404 13.25 21.25L13.25 6.76777L19.8661 13.3839C20.3543 13.872 21.1457 13.872 21.6339 13.3839C22.122 12.8957 22.122 12.1043 21.6339 11.6161L12.8857 2.86793C12.8805 2.86276 12.8754 2.85764 12.8701 2.85256C12.7545 2.74037 12.6225 2.65495 12.482 2.59631C12.3337 2.53427 12.1708 2.5 12 2.5C11.659 2.5 11.3498 2.63657 11.1243 2.858C11.1212 2.86106 11.1181 2.86415 11.115 2.86725L2.36612 11.6161C1.87796 12.1043 1.87796 12.8957 2.36612 13.3839C2.85427 13.872 3.64573 13.872 4.13389 13.3839L10.75 6.76777L10.75 21.25Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  })))));
};
var Memo = /*#__PURE__*/memo(SvgSortUp);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "transfix-icons/icons/SortUp.e24a0fce0a1652e0abf4d1fb2564d7e6.svg";